import ecommerceimgone from "../assets/ecommerce/ecommeceimgone.jpg";
import ecommerceimgtwo from "../assets/ecommerce/ecommerceimgtwo.jpg";
import ecommerceimgthree from "../assets/ecommerce/ecommerceimgthree.jpg";

const Ecommrcedata = [
  {
    icon: ecommerceimgone,
    // path: "Web-Development",
  },

  {
    icon: ecommerceimgtwo,
    // path:"Digital-Marketing"
  },

  {
    icon: ecommerceimgthree,
    // path:"Web-Services"
  },
];

export default Ecommrcedata;
